// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2TFBk","author":"Table_author__10EPz","authorImage":"Table_authorImage__C1HHw","unreadRow":"Table_unreadRow__3vdOW"};